'use client'

import { useState } from 'react'

type BookHeaderProps = {
  title: string
  subtitle?: string | null
  about?: string | null
  headingLevel?: 'h1' | 'h2' | 'span'
}

export function BookHeader({ title, subtitle, about, headingLevel = 'h1' }: BookHeaderProps) {
  const Heading = headingLevel
  const [showInfo, setShowInfo] = useState(false)

  return (
    <section className="app-form px-xxl pt-l pb-m">
      {/* Title row with info icon */}
      <div className="flex items-center justify-between gap-m">
        <Heading className="text-l font-bold">{title}</Heading>
        {about && (
          <button
            onClick={() => setShowInfo(!showInfo)}
            className="w-11 h-11 flex items-center justify-center cursor-pointer shrink-0"
            aria-label="About this book"
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 8V8.01M12 12V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        )}
      </div>

      {/* Subtitle */}
      {subtitle && (
        <p className="text-m text-text-inactive mt-s">{subtitle}</p>
      )}

      {/* Collapsible info box */}
      {about && showInfo && (
        <div className="border border-stroke-primary border-dashed rounded-lg p-l flex items-start gap-s mt-m">
          <span className="text-m text-text-primary shrink-0 leading-medium">ⓘ</span>
          <p className="text-m text-text-primary whitespace-pre-line text-left leading-medium">
            {about}
          </p>
        </div>
      )}
    </section>
  )
}
